import { useAuth } from '@hourly/contexts/AuthContext';
import { useRequest } from '@hourly/hooks/useRequest';
import { AxiosError } from 'axios';
import useErrorDialog from '../../../../_shared/data/hooks/dialog/useErrorDialog';
import { createReferralRequest } from '../requests/createReferral.request';

type CreateReferralInput = {
  firstName: string;
  lastName: string;
  companyName: string;
  email?: string;
  mobileNumber?: string;
  note: string;
};

const useCreateReferral = () => {
  const { sessionState } = useAuth();
  const { error: errorDialog } = useErrorDialog();
  const { request } = useRequest(
    async (data: CreateReferralInput) => {
      return await createReferralRequest({
        ...data,
        partnerId: sessionState.partnerId ?? '',
      });
    },
    {
      onError: (error) => {
        const axiosError = error as AxiosError<{ error_detailed_message?: string }>;
        const errorMessage =
          axiosError.response?.data?.error_detailed_message ?? 'Unexpected error occurred';
        errorDialog({ content: errorMessage });
      },
    }
  );

  return request;
};

export default useCreateReferral;
